var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "cart-widget",
      attrs: { "data-overlay-toggle": !_vm.hasCart },
      on: { click: _vm.onCartClick },
    },
    [
      _vm.hasCart
        ? [
            _c(
              "div",
              { staticClass: "cart-widget__cart" },
              [
                _c("SVGCart"),
                _vm._v(" "),
                _vm.cartAmount
                  ? [
                      _c("span", { staticClass: "cart-widget__count" }, [
                        _vm._v(_vm._s(_vm.cartAmount)),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "cart-widget__text" }, [
                  _vm._v(_vm._s(_vm.cartPriceDisplay)),
                ]),
              ],
              2
            ),
          ]
        : [
            _c("SVGCart"),
            _vm._v(" "),
            _c("a", { attrs: { href: "https://shop.loasia.ch/" } }, [
              _c("span", { staticClass: "cart-widget__text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("minicart.orderText")) +
                    "\n      "
                ),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }